"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconChargingStationsOnMap = function IconChargingStationsOnMap(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M23.99 4.33c-7.336 0-13.53 6.929-13.53 14.83 0 3.232 2.027 7.951 6.008 14.17q.327.51.683 1.05l.362.545q.4.6.83 1.227a194 194 0 0 0 3.339 4.722l1.52 2.058.824 1.094 1.215-1.723a344 344 0 0 0 3.842-5.605l.912-1.37.96-1.467.336-.52.583-.922c3.598-5.769 5.426-10.19 5.416-13.262 0-7.943-5.999-14.827-13.3-14.827m0 2c6.13 0 11.3 5.932 11.3 12.83.009 2.674-1.8 6.963-5.402 12.66l-.28.44q-.488.761-1.032 1.588l-.505.763a303 303 0 0 1-2.674 3.956l-1.421 2.054-.678-.925a192 192 0 0 1-3.305-4.672l-.55-.812-.267-.398q-.543-.814-1.024-1.564l-.554-.876c-3.42-5.48-5.138-9.61-5.138-12.214 0-6.844 5.352-12.83 11.53-12.83M23.88 10a8.48 8.48 0 1 0 0 16.96 8.48 8.48 0 0 0 0-16.96m0 1a7.48 7.48 0 1 1 0 14.96 7.48 7.48 0 0 1 0-14.96",
    clipRule: "evenodd"
  })));
};

export { IconChargingStationsOnMap, IconChargingStationsOnMap as default };
